import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'A vendor-neutral PDF technical reference to telecommunications and fiber optic networks: fiber and OTDR, structured cabling, FTTH and PON, microwave links, cell sites and network operations. 6 volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-navy-950 font-sans text-silver antialiased" data-id="element-0" data-mp="su42zd55eud4">
      <MetaPixel data-id="element-1" data-mp="35ozsypftiwt" />
      <main data-id="element-2" data-mp="356t1855fman">
        <Hero data-id="element-3" data-mp="34x4zq3nzp7l" />
        <LookInsideCarousel data-id="element-4" data-mp="38kv0f9whthk" />
        <ProblemSection data-id="element-5" data-mp="3ud1f186rfma3" />
        <SystemSection data-id="element-6" data-mp="3ubrgkhvzwc2x" />
        <ModulesSection data-id="element-7" data-mp="3uc9o4ao3ycq5" />
        <BonusSection data-id="element-8" data-mp="3uf5gljh6s977" />
        <UrgencySection data-id="element-9" data-mp="d57g95652mk4" />
        <PricingSection data-id="element-10" data-mp="d3mil6oj2ni1" />
        <GuaranteeSection data-id="element-11" data-mp="d3wc348s7csh" />
        <FAQ data-id="element-12" data-mp="85l1usekr09q" />
        <ClosingSection data-id="element-13" data-mp="851kbcsu6dw8" />
        <SummaryTable data-id="element-14" data-mp="86mgf6usu4w7" />
        <FinalCta data-id="element-15" data-mp="86cmx9ajpflr" />
      </main>
      <Footer data-id="element-16" data-mp="3gle90gn0mze4" />
      <PurchaseNotification data-id="element-17" data-mp="3gkv0fqj99ncr" />
    </div>;
}